/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ResourceStatusResponse } from '../models/resource-status-response';
import { ResourceSyncRequest } from '../models/resource-sync-request';
import { ReleasePreviewResponse } from '../models/release-preview-response';

/**
 * Ui Resource Status Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiResourceStatusControllerService extends __BaseService {
  static readonly syncResourceUsingPOSTPath = '/cc-ui/v1/resources/sync';
  static readonly getReleasePreviewUsingGETPath =
    '/cc-ui/v1/resources/{clusterId}/release-preview';
  static readonly getResourceStatusUsingGETPath =
    '/cc-ui/v1/resources/{projectName}/{environmentName}/status';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * syncResource
   * @param request request
   * @return OK
   */
  syncResourceUsingPOSTResponse(
    request: ResourceSyncRequest,
  ): __Observable<__StrictHttpResponse<ResourceStatusResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/resources/sync`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResourceStatusResponse>;
      }),
    );
  }
  /**
   * syncResource
   * @param request request
   * @return OK
   */
  syncResourceUsingPOST(
    request: ResourceSyncRequest,
  ): __Observable<ResourceStatusResponse> {
    return this.syncResourceUsingPOSTResponse(request).pipe(
      __map((_r) => _r.body as ResourceStatusResponse),
    );
  }

  /**
   * getReleasePreview
   * @param clusterId clusterId
   * @return OK
   */
  getReleasePreviewUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<ReleasePreviewResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/resources/${encodeURIComponent(
          String(clusterId),
        )}/release-preview`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReleasePreviewResponse>;
      }),
    );
  }
  /**
   * getReleasePreview
   * @param clusterId clusterId
   * @return OK
   */
  getReleasePreviewUsingGET(
    clusterId: string,
  ): __Observable<ReleasePreviewResponse> {
    return this.getReleasePreviewUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as ReleasePreviewResponse),
    );
  }

  /**
   * getResourceStatus
   * @param params The `UiResourceStatusControllerService.GetResourceStatusUsingGETParams` containing the following parameters:
   *
   * - `resources`: resources
   *
   * - `projectName`: projectName
   *
   * - `environmentName`: environmentName
   *
   * @return OK
   */
  getResourceStatusUsingGETResponse(
    params: UiResourceStatusControllerService.GetResourceStatusUsingGETParams,
  ): __Observable<__StrictHttpResponse<ResourceStatusResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.resources != null)
      __params = __params.set('resources', params.resources.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/resources/${encodeURIComponent(
          String(params.projectName),
        )}/${encodeURIComponent(String(params.environmentName))}/status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResourceStatusResponse>;
      }),
    );
  }
  /**
   * getResourceStatus
   * @param params The `UiResourceStatusControllerService.GetResourceStatusUsingGETParams` containing the following parameters:
   *
   * - `resources`: resources
   *
   * - `projectName`: projectName
   *
   * - `environmentName`: environmentName
   *
   * @return OK
   */
  getResourceStatusUsingGET(
    params: UiResourceStatusControllerService.GetResourceStatusUsingGETParams,
  ): __Observable<ResourceStatusResponse> {
    return this.getResourceStatusUsingGETResponse(params).pipe(
      __map((_r) => _r.body as ResourceStatusResponse),
    );
  }
}

module UiResourceStatusControllerService {
  /**
   * Parameters for getResourceStatusUsingGET
   */
  export interface GetResourceStatusUsingGETParams {
    /**
     * resources
     */
    resources: any;

    /**
     * projectName
     */
    projectName: string;

    /**
     * environmentName
     */
    environmentName: string;
  }
}

export { UiResourceStatusControllerService };
